"use strict";

angular.module('app.modals.userLevelLogin', [])

    .controller('userLevelLoginModalCtrl', ['$scope','close','API','f_User',
        function ($scope,close,API,f_User ) {
            $scope.close = function(a)
            {
                close(a);
            }
            $scope.sendLogin = function (o) {

                $scope.loginIncorrect = false;
                $scope.loading = true;
                var pv = {'Password': o.expertpassword};
                var _API = new API();
                _API.User.UserLevelLogin(pv).
                $promise.
                then(
                    function (data) {
                        if (f_User.getUserLevel() <= data.userlevel) {
                            f_User.setUserLevel(data.userlevel);
                            $scope.loginIncorrect = false;
                            close(data);
                        } else {
                            $scope.loginIncorrect = true;
                        }
                        $scope.loading = false;
                       // $rootScope.loading = false;
                    },
                    function(data) {
                        $scope.wrongLogin = true;
                        $scope.loading = false;
                    }
                );

                o.expertpassword = '';


            };
        }
    ])

    .factory('userLevelLoginModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (favoriteObject) {

            return ModalService.showModal({
                templateUrl: "views/modals/userLevelLogin.html",
                controller: 'userLevelLoginModalCtrl'

            });


        }
    }]);